define('ordersUnpaidFiltersEditView',[
  'module',
  'ordersListFiltersEditView'
], function(
  Module,
  OrdersFiltersEditView
) {
  'use strict';

  Module.exports = OrdersFiltersEditView.extend({
    onShow: function() {
      OrdersFiltersEditView.prototype.onShow.apply(this, arguments);
      // payedByCustomer is forced to false on this screen
      this.$el.find('.payment.item').hide();
    }
  });
});

